var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCamera360 = function SvgCamera360(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.4 35.1",
    style: {
      enableBackground: "new 0 0 41.4 35.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#15152A",
      strokeWidth: 2.0384,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M38.7,19.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15152A"
    },
    d: "M33.5,33.5h-26c-2.9,0-5.1-2.3-5.1-5.1V11c0-2.9,2.3-5.1,5.1-5.1h26c2.9,0,5.1,2.3,5.1,5.1v17.4 C38.6,31.2,36.2,33.5,33.5,33.5z M7.5,7.9c-1.7,0-3.1,1.4-3.1,3.1v17.4c0,1.7,1.4,3.1,3.1,3.1h26c1.7,0,3.1-1.4,3.1-3.1V11 c0-1.7-1.4-3.1-3.1-3.1C33.5,7.9,7.5,7.9,7.5,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15152A"
    },
    d: "M26.1,26.3c-3.7,0-6.7-3-6.7-6.6s3-6.6,6.7-6.6c3.7,0,6.7,3,6.7,6.6S29.8,26.3,26.1,26.3z  M26.1,15c-2.5,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7c2.5,0,4.7-2.1,4.7-4.7S28.7,15,26.1,15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15152A"
    },
    d: "M15.2,7.9H6.3c-0.6,0-1-0.5-1-1V3.5c0-1,0.8-1.9,1.9-1.9h7.1c1,0,1.9,0.8,1.9,1.9v3.4 C16.2,7.5,15.8,7.9,15.2,7.9z M7.3,5.9h6.8V3.6H7.3C7.3,3.6,7.3,5.9,7.3,5.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#15152A"
    },
    cx: 10.3,
    cy: 13.7,
    rx: 2.3,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15152A"
    },
    d: "M19.5,20.6H3.3c-0.6,0-1-0.5-1-1s0.5-1,1-1h16.1c0.6,0,1,0.5,1,1S20,20.6,19.5,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15152A"
    },
    d: "M37.6,20.6h-5.8c-0.6,0-1-0.5-1-1s0.5-1,1-1h5.8c0.6,0,1,0.5,1,1S38.2,20.6,37.6,20.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#15152A",
      strokeWidth: 2.0384,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M44.9,25.5"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera360, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Camera360.f1605294.svg";
export { ForwardRef as ReactComponent };